import { Fragment } from "react";
import DataTableCommon from "../../../Templates/DataTable/DataTableCommon";
import PengaturanListLayout from "../../../../Layout/Components/PengaturanListLayout";
import DataTableTitle from "../../../DataTableComponents/DataTableTitle";
import KurirModal from "./KurirModal";


const KurirList = ({ items, resetState, pending }) => {
  
  const columns = [
    {
      name: <DataTableTitle text="ID" />,
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: <DataTableTitle text="Nama" />,
      selector: (row) => row.nama,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text="Operations" />,
      width: "15%",
      cell: (row) => (
        <div>
          <KurirModal create={false} data={row} resetState={resetState} />
        </div>
      ),
    },
  ]
  
  return (
    <PengaturanListLayout
      items={items}
      itemColumns={columns}
      // searchCategories={}
      pending={pending}
    />
  );
}

export default KurirList;